import find from 'lodash/find'
import filter from 'lodash/filter'

export default {
  getPersonalTypes: state => state.personalTypes,
  getPersonalTypeSelected: state => find(state.personalTypes, 'selected'),
  getUserInfo: state => state.userInfo,
  getAccountInfo: state => state.accountInfo,
  getPayments: state => state.payments.items,
  getSelectedPayments: state => find(state.payments.items, 'selected'),
  getIsInnerPaymentShow: state => state.payments.isInnerShow,
  getIsInnerPaymentSelected: state => state.payments.isInnerSelected,
  getInnerPayment: state => state.payments.inner,
  getPriceDelivery: state => state.price.delivery,
  getPriceOrder: state => state.price.order,
  getPriceSum: state => state.price.sum,
  getIsSubscribe: state => state.isSubscribe,
  getBasketUrl: state => state.basket.url,
  getBasketPrice: state => state.basket.price,
  getBasketItems: state => state.basket.items,
  getDeliveryCountryList: state => state.delivery.country,
  getDeliveryCountrySelected: state => find(state.delivery.country, 'selected'),
  getDeliveryCountryUnselected: state => filter(state.delivery.country, e => !e.selected),
  getDeliveryTypes: state => state.delivery.types,
  getDeliveryTypeSelected: state => find(state.delivery.types, 'selected'),
  getDeliveryFields: state => state.delivery.fields,
  getDeliveryServiceFields: state => state.delivery.serviceFields,
  getDeliveryServiceFieldByCode: state => code => find(state.delivery.serviceFields, e => e.code === code),
  getDeliveryFieldByCode: state => code => find(state.delivery.fields, e => e.code === code),
  getDeliveryFieldByType: state => type => find(state.delivery.fields, e => e.type === type),
  getDeliveryFieldById: state => id => find(state.delivery.fields, e => e.id === id),
  getDeliveryItems: state => state.delivery.items,
  getDeliveryPickupItems: state => state.delivery.pickupItems,
  getDeliveryPickupItemSelected: state => find(state.delivery.pickupItems, 'selected'),
  getDeliveryItemSelected: state => find(state.delivery.items, 'selected'),
  getIsShowLoadData: state => state.isShowLoadData,
  getValidateUserInfo: state => state.isValidateUserInfo,
  getValidateAccountInfo: state => state.isValidateAccountInfo,
  getValidateDelivery: state => state.isValidateDelivery,
  getGlobalErrors: state => state.globalErrors,
  getProfileList: state => state.profileList,
  getSelectedProfile: state => find(state.profileList, e => e.selected),
  getIsAuthorized: state => state.isAuthorized,
  isStorePickup: (state, getters) => getters.getDeliveryItemSelected && getters.getDeliveryItemSelected.code === 'storePickup',
  getMovingStatus: (state) => state.movingStatus
}



// WEBPACK FOOTER //
// ./src/components/store/modules/order/getters.js